import React, { Component } from 'react';
import * as t from '../translate';
import {langs} from '../translate/langs';
import {browserHistory } from 'react-router'
import NavBar from './NavBar'
import Footer from './Footer';

export default class InterfaceLang extends Component {

    constructor (props) {
        super(props);
        this.state = {
            interfaceLang: 'en'
        };
    }

    componentWillMount() {
        let idx, iLang;
        let pushUrl = '/404';
        let allLangs = Object.keys(langs);

        // we either have our interface lang from the url or a prop
        if (this.props.params.interfaceLang || this.props.interfaceLang){
            iLang = this.props.params.interfaceLang || this.props.interfaceLang;
            idx = allLangs.indexOf(iLang);
            if (idx !== -1){
                this.setState({
                    interfaceLang: iLang
                });
                pushUrl = ['', iLang, iLang].join('/'); // e.g. /en/en
            }
            // set language of page
            document.documentElement.lang = iLang;
        }
        browserHistory.replace(pushUrl);
    }

    render(){
        let iLang = this.state.interfaceLang;
        let children = React.Children.map(this.props.children, function (child) {
            return React.cloneElement(child, {
                interfaceLang: iLang
            });
        });
        let navText = t.t('sewing translator', this.state.interfaceLang);

        return (
            <div>
                <NavBar navText={navText} />
                {children}
                <Footer lang={this.state.interfaceLang} />
            </div>
        );
    }

}





/** WEBPACK FOOTER **
 ** ./src/components/InterfaceLang.js
 **/